import React, { useEffect, useState } from 'react';

const ComplianceIndicator = ({ percentage }) => {
    const [fillPercentage, setFillPercentage] = useState(0);

    useEffect(() => {
        // Asegurar que el porcentaje esté entre 0 y 100
        const safePercentage = Math.min(100, Math.max(0, percentage));
        
        // Usar setTimeout para asegurar que la animación se active en el siguiente ciclo de render
        const timer = setTimeout(() => {
            setFillPercentage(safePercentage);
        }, 0);

        return () => clearTimeout(timer);
    }, [percentage]);

    // Calcular el ángulo para el arco
    const circumference = 2 * Math.PI * 45; // radio de 45
    const dashOffset = circumference * (1 - fillPercentage / 100);

    return (
        <div className="compliance-indicator-circle">
        <svg width="100" height="100" viewBox="0 0 100 100">
            <circle 
                cx="50" 
                cy="50" 
                r="45" 
                fill="none" 
                stroke="#e0e0e0" 
                strokeWidth="10"
            />
            <circle 
                cx="50" 
                cy="50" 
                r="45" 
                fill="none" 
                stroke="var(--morado-oscuro, #5664D2)" 
                strokeWidth="10"
                strokeDasharray={circumference}
                strokeDashoffset={dashOffset}
                style={{
                    transition: 'stroke-dashoffset 0.8s ease-in-out',
                    transformOrigin: '50% 50%',
                    transform: 'rotate(-90deg)'
                }}
            />
            <text 
                x="50" 
                y="50" 
                textAnchor="middle" 
                dy=".3em" 
                fontSize="20"
                fill="#666"
            >
                {fillPercentage.toFixed(0)}%
            </text>
        </svg>
    </div>
    );
};

export default ComplianceIndicator;
